import React, { useEffect } from "react"

import { generateDocumentTitle } from "../../../constants/document-title.ts"
import { SettingsListsHub } from "../components/settings-lists/SettingsListsHub.tsx"

export default function SettingsListsPage() {
  useEffect(() => {
    generateDocumentTitle("Settings Drop-down Lists")
  }, [])

  return <SettingsListsHub />
}
